<div class="container">
  <span style="padding: 2%; font-size: 13px;">{{data['message']}}</span>
  <mat-icon class="icon-class" style="color: #00d689;" *ngIf="data['type'] === 'success'">check_circle_outline</mat-icon>
  <mat-icon class="icon-class" style="color: #ff5252;" *ngIf="data['type'] === 'failure'">highlight_off</mat-icon>
</div>
